import axios from 'axios'
import { type DocumentMeta, readDocumentMeta } from '@/services/api/site'

export type UserType = {
  id: number
  name: string
}

export async function getCustomerVisitorUserTypes(
  customerId: number,
): Promise<UserType[]> {
  const response = await axios.get(
    `/api/customers/${customerId}/visitor-user-types`,
  )

  return response.data.data
}

export async function getLocationRequiredForUserType(
  customerId: number,
  userTypeId: number,
): Promise<boolean> {
  const response = await axios.get(
    `/api/customers/${customerId}/user-types-requiring-location/${userTypeId}`,
  )
  return response.data.data.required
}

export async function getCustomerWorkOrderUserTypes(
  customerId: number,
): Promise<UserType[]> {
  const response = await axios.get(
    `api/customers/${customerId}/work-order-user-types`,
  )

  return response.data.data
}

export const getCustomerDocumentMeta = async (
  customerId: number,
  documentId: number,
): Promise<DocumentMeta> =>
  readDocumentMeta(`/api/documents/${documentId}`, documentId)
